import apiClient from '@/api/client';
import { useAuthStore } from '@/stores/authStore';
import { clearTokens } from '@/utils/cookies';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const logout = async (refresh: string): Promise<void> => {
  await apiClient.post('users/logout/', { refresh });
};

export const useLogout = () => {
  const queryClient = useQueryClient();
  const { clearAuthState } = useAuthStore();

  return useMutation({
    mutationFn: logout,
    onSettled: () => {
      clearTokens();
      clearAuthState();
      queryClient.clear();
      // logging out on landing page will not redirect user back to login page
      if (window.location.pathname !== '/') window.location.href = '/login';
    },
    onError: (error: any) => {
      console.error(error);
    },
  });
};
